import {FC} from 'react'
import {dateFormat} from 'libs/formatter'
import {List, ListHeader, ListItem, ListArrow, AlertItem, AlertLink, Indicator, AlertDate, StaffCode} from './List'
import {CommentAlerts as CommentAlertsData} from './query'

const DISPLAY_COMMENT_ALERT_COUNT = 5

interface CommentAlertsProps {
  commentAlerts: CommentAlertsData
}

export const CommentAlerts: FC<CommentAlertsProps> = ({commentAlerts}) => {
  if (commentAlerts.comments.length === 0) {
    return null
  }
  const extraCommentAlertsCount = commentAlerts.totalCount - DISPLAY_COMMENT_ALERT_COUNT

  return (
    <div>
      <ListHeader>従業員のメモ</ListHeader>
      <List>
        {commentAlerts.comments.map((comment) => (
          <ListItem key={comment.id}>
            <AlertLink
              to={{
                pathname: `/employees/${comment.commentable.id}`,
                state: {from: 'alerts'},
              }}
            >
              <Indicator color={comment.color} />
              <AlertDate>{dateFormat(comment.alertAt, 'YYYY年MM月DD日')}</AlertDate>
              {comment.commentable.staffCode && <StaffCode>{comment.commentable.staffCode}</StaffCode>}
              <span>{comment.commentable.displayFullName}</span>
              <ListArrow />
            </AlertLink>
          </ListItem>
        ))}
        {extraCommentAlertsCount > 0 && (
          <ListItem>
            <AlertItem>その他{extraCommentAlertsCount}件のメモアラートがあります</AlertItem>
          </ListItem>
        )}
      </List>
    </div>
  )
}
